const state = {
  filter: {},
  selected: []
};

const getters = {
  filter: (state) => {
    return state.filter || {};
  },
  selected: (state) => {
    return state.selected || [];
  }
};

const mutations = {
  SET_FILTER(state, item) {
    state.filter = Object.entries(item).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
  },
  SET_SELECTED(state, item) {
    state.selected = item;
  }
};

const actions = {
  filter({ commit }, item) {
    commit('SET_FILTER', item);
  },
  setSelected({ commit }, item) {
    commit('SET_SELECTED', item);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
